import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Building2, LineChart, Sparkles } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("rajbinde@gmail.com");
  const [password, setPassword] = useState("Admin@Param2026");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      {/* Left brand panel */}
      <div className="hidden md:flex flex-col justify-between bg-zinc-950 text-white p-10 relative overflow-hidden">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-md bg-emerald-600 grid place-items-center font-heading font-extrabold text-lg">P</div>
            <div>
              <div className="font-heading text-lg font-bold">Param Developers</div>
              <div className="text-[11px] uppercase tracking-widest text-zinc-400">Enterprise ERP</div>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <h1 className="font-heading text-4xl lg:text-5xl font-bold leading-[1.05]">
            One operating system for every project, ledger and lead.
          </h1>
          <p className="text-zinc-400 max-w-md leading-relaxed">
            Multi-site accounting, live inventory sales boards, JDA revenue sharing, GST/TDS ready
            reports, and an always-on AI assistant — built for Indian real-estate.
          </p>

          <div className="grid grid-cols-3 gap-4 pt-4">
            {[
              { icon: Building2, label: "Multi-Project" },
              { icon: LineChart, label: "Live P&L" },
              { icon: Sparkles, label: "AI Insights" },
            ].map((f) => (
              <div key={f.label} className="border border-white/10 rounded-md p-4">
                <f.icon size={18} className="text-emerald-400" />
                <div className="mt-2 text-xs uppercase tracking-widest text-zinc-300">{f.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-xs text-zinc-500 font-mono">v1.0 · Feb 2026 · Made in Pune</div>

        <div className="absolute -right-24 -bottom-24 w-96 h-96 rounded-full bg-emerald-600/10 blur-3xl pointer-events-none" />
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-6 md:p-10 bg-zinc-50">
        <form onSubmit={onSubmit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <div className="md:hidden flex items-center gap-3 mb-8">
              <div className="w-10 h-10 rounded-md bg-emerald-600 grid place-items-center font-heading font-extrabold text-white">P</div>
              <div className="font-heading font-bold">Param Developers</div>
            </div>
            <h2 className="font-heading text-2xl font-bold">Sign in</h2>
            <p className="text-sm text-zinc-500 mt-1">Access the Param Developers Enterprise ERP.</p>
          </div>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-widest text-zinc-500">Email</Label>
              <Input
                id="email" type="email" required autoComplete="email"
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1 h-11 border-zinc-300"
                data-testid="login-email"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-widest text-zinc-500">Password</Label>
              <Input
                id="password" type="password" required autoComplete="current-password"
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1 h-11 border-zinc-300"
                data-testid="login-password"
              />
            </div>
          </div>

          <Button
            type="submit"
            className="w-full h-11 bg-emerald-700 hover:bg-emerald-800 text-white"
            disabled={busy}
            data-testid="login-submit"
          >
            {busy ? "Signing in…" : "Sign in"}
          </Button>

          <p className="text-[11px] text-zinc-500 font-mono">
            Owner account seeded: rajbinde@gmail.com / Admin@Param2026
          </p>
        </form>
      </div>
    </div>
  );
}
